import common from "./common";
import appHeader from "./appHeader";
import login from "./login";
import language from "./language";
import home from "./home";
import menu from "./menu";
import systemSetting from "./systemSetting";
import contractManagement from "./contractManagement";
import inquiryManagement from "./inquiryManagement";
import safeWarning from "./safeWarning";
import resetPassword from "./resetPassword";
import purchaseRequestManagement from "./purchaseRequestManagement";
import sourcingRequirementManagement from "./sourcingRequirementManagement";
import performanceAssessmentTemplate from "./performanceAssessmentTemplate";
import deptSelectorModal from "./deptSelectorModal";
import admissionAssessmentTemplate from "./admissionAssessmentTemplate";
import supplierPerformance from "./supplierPerformance";
import supplierVisitAndAudit from "./supplierVisitAndAudit";
import option from "./option";
import supplierProfile from "./supplierProfile";
import supplierRiskLevel from "./supplierRiskLevel";
import blacklist from "./blacklist";
import materialExceptionLevel from "./materialExceptionLevel";
import order from "./order";
import evaluationTab from "./evaluationTab";

const resources = {
  common,
  appHeader,
  login,
  language,
  home,
  menu,
  systemSetting,
  contractManagement,
  inquiryManagement,
  safeWarning,
  resetPassword,
  purchaseRequestManagement,
  sourcingRequirementManagement,
  performanceAssessmentTemplate,
  deptSelectorModal,
  admissionAssessmentTemplate,
  supplierPerformance,
  supplierVisitAndAudit,
  option,
  supplierProfile,
  supplierRiskLevel,
  blacklist,
  materialExceptionLevel,
  order,
  evaluationTab,
};

export default resources;
